import * as React from "react";
import { dispatch } from "@rematch/core";
import { connect } from "react-redux";
import { Select } from "antd";
const Option = Select.Option;

interface IProps {
  value?: any;
  field?: any;
  modelName?: any;
  onChange?: any;
  setValue?: any;
  width?: any;
  placeholder?: any;
  share?: any;
  defaultValue?: any;
}

interface ISelectorData {
  id: string;
  name: string;
}

interface ISelectorProps extends IProps {
  // 数据源
  data?: [ISelectorData];
  // 数据源名称（匹配异步接口）
  selectorName?: any;
  // 异步数据，供应商接口(由reudx提供)
  getSupplier?: any;
  // 异步数据，商品分类列表接口(由reudx提供)
  getProductCate?: any;
  // 异步数据，客服列表接口(由reudx提供)
  getUser?: any;
  // 异步数据，获取商城订单来源接口(由reudx提供)
  getStoreOrderSource?: any;
  // 用于找到父节点的选择器
  containerBody?: any;
}

// 下拉列表组件
class Selector extends React.Component<ISelectorProps, any> {
  constructor(props: ISelectorProps) {
    super(props);
    this.state = {
      data: [],
      defaultValues: '',
    };
  }

  //componentWillMount() {
  componentDidMount() {
    if (!this.props.data && this.props.selectorName) {
      switch (this.props.selectorName) {
        // 供应商列表 订单列表 供应商选择的是名称，需要根据名称来查询
        case "supplier":
          this.props.getSupplier();
          break;
        // 商品分类列表
        case "productCate":
          this.props.getProductCate();
          break;
        // 客服列表
        case "user":
          this.props.getUser().then(res => {
            let data: any = [];

            if (!this.props.data && this.props.selectorName) {
              data = this.props.share[this.props.selectorName] || [];
              // 客服需要特殊处理，要加一个未签名选项
              if ("user" === this.props.selectorName) {
                data = [
                  {
                    id: -1,
                    name: "未签名",
                    isLock: 0
                  },
                  ...data
                ];
              }
            } else {
              data = this.props.data || [];
            }

            if (this.props.selectorName == 'user') {
              data.map(item => {
                if (item.id == this.props.defaultValue) {
                  this.setState({
                    defaultValues: item.id
                  })
                  let _data = {};
                  _data[this.props.field] = item.id;
                  dispatch["antDemo"].setValue({
                    formInfo: _data,
                    model: this.props.modelName,
                    field: this.props.field,
                    value: item.id
                  });
                }
              })
            }
          })
          break;
        // 商城订单来源列表
        case "storeOrderSource":
          this.props.getStoreOrderSource();
          break;
        default:
          break;
      }
    }
  }


  getContainer = () => {
    const containerBody = this.props.containerBody;
    if (containerBody) {
      return document.querySelector(containerBody) || document.body;
    } else {
      return document.body;
    }
  };

  render() {
    let data: any = [];

    if (!this.props.data && this.props.selectorName) {
      data = this.props.share[this.props.selectorName] || [];
      // 客服需要特殊处理，要加一个未签名选项
      if ("user" === this.props.selectorName) {
        data = [
          {
            id: -1,
            name: "未签名",
            isLock: 0
          },
          ...data
        ];
      }
    } else {
      data = this.props.data || [];
    }
    // 遍历数据项
    let getData: any = () => {
      let options: any = [];
      data.forEach((item, index) => {
        // 验证数据格式
        if (!(item && item.id && item.name)) {
          console.warn(
            "格式错误",
            item,
            " 传递给Selector的数据格式应该如此：",
            [{ id: "XXX", name: "XXX" }]
          );
        } else {
          let id = "";
          switch (this.props.selectorName) {
            // 供应商列表 订单列表 供应商选择的是名称，需要根据名称来查询
            case "supplier":
              id = item.name;
              break;
            default:
              id = item.id;
              break;
          }

          options.push(
            <Option key={index} value={id}>
              {item.name}
            </Option>
          );
        }
      });

      return options;
    };

    // 当数据已加载完成时才设置选中的值,这样处理可以避免由于数据集加载而造成的闪烁
    let value = undefined;

    if (data) {
      value = data.length ? this.props.value || undefined : undefined;
    }
    const onChange = e => {
      let data = {};
      data[this.props.field] = e;
      dispatch["antDemo"].setValue({
        formInfo: data,
        model: this.props.modelName,
        field: this.props.field,
        value: e
      });
    };

    // 根据关键字检索option
    const filter = (input, option) =>
      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    return (
      <React.Fragment>
        {
          <Select
            value={value}
            placeholder={this.props.placeholder || "选择一项"}
            style={{ width: this.props.width || 140 }}
            allowClear={true}
            onChange={this.props.onChange || onChange}
            getPopupContainer={this.getContainer}
            // 检索相关
            showSearch
            optionFilterProp="children"
            filterOption={filter}
          // 检索相关
          >
            {getData()}
          </Select>
        }
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  share: state.share
});

const mapDispatch = dispatch => {
  return {
    getSupplier: dispatch.selectorSource.getSupplier,
    getProductCate: dispatch.selectorSource.getProductCate,
    getUser: dispatch.selectorSource.getUser,
    getStoreOrderSource: dispatch.selectorSource.getStoreOrderSource
  };
};

export default connect(
  mapState,
  mapDispatch
)(Selector);
